module.exports = __webpack_public_path__ + "static/media/alshammelCarBlue.2ebff37d.svg";